/* eslint-disable react-hooks/exhaustive-deps */
import { InfoIcon } from '@chakra-ui/icons';
import { Popover, PopoverArrow, PopoverBody, PopoverContent, PopoverTrigger, Text, useDisclosure } from '@chakra-ui/react';
import 'moment/locale/en-gb';

function Tip({ childDescription = null, decription = null }) {
	const modal = useDisclosure();

	return (
		<Popover size="sm" isOpen={modal?.isOpen} onClose={modal?.onClose} placement="auto">
			<PopoverTrigger>{(childDescription || decription) && <InfoIcon color="gray.400" boxSize="14px" onClick={modal?.onOpen} />}</PopoverTrigger>
			<PopoverContent _focus={{ boxShadow: 'none', outline: 'none' }}>
				<PopoverArrow />
				<PopoverBody>
					{childDescription ? (
						<>{childDescription}</>
					) : (
						<>
							<Text fontSize="sm" fontWeight="400" color="blue.500">
								{decription ?? ''}
							</Text>
						</>
					)}
				</PopoverBody>
			</PopoverContent>
		</Popover>
	);
}

export default Tip;
